<script>
    import FilterEditObject from '@/components/page-filter-edit/FilterEditObject.vue';

    export default {
        props: {
            assetType: Object,
        },
        computed: {
            filters() {return this.$store.getters.FILTER_BY_ASSET_TYPE(this.assetType.id)}
        },
        components: {
            FilterEditObject: FilterEditObject,
        }
    }
</script>


<template>
    <div class="right_header">
        <label>{{ assetType['name'] }}</label>
    </div>
    <div class="border_sub_container">
        <FilterEditObject 
            v-for="(filterValue, filterIndex) in filters" :key="filterIndex"
            :filter="filterValue"
        />
    </div>
</template>